import HomeRouter from './Home';
import FantasyRouter from './Fantasy';
import LeaguesRouter from './Leagues';
import StatsRouter from './Stats';
import MatchCentreRouter from './MatchCentre';
import OnboardingRouter from './Onboarding';
import PriceRevealRouter from './PriceReveal';
import HelpRouter from './Help';
import AccountRouter from './Account';
import DraftRouter from './Draft';
import FantasyCoachRouter from './FantasyCoach';
// import PulseRouter from './Pulse';
import GameSelectorRouter from './GameSelector';
import ActivateGameRouter from './ActivateGame';
import PasswordRouter from './Password';
import OffSeasonRouter from './OffSeason';

export { HomeRouter };
export { FantasyRouter };
export { LeaguesRouter };
export { StatsRouter };
export { MatchCentreRouter };
export { OnboardingRouter };
export { PriceRevealRouter };
export { HelpRouter };
export { AccountRouter };
export { DraftRouter };
// export { PulseRouter };
export { GameSelectorRouter };
export { ActivateGameRouter };
export { PasswordRouter };
export { FantasyCoachRouter };
export { OffSeasonRouter };

export default {
	HomeRouter,
	FantasyRouter,
	LeaguesRouter,
	StatsRouter,
	MatchCentreRouter,
	OnboardingRouter,
	PriceRevealRouter,
	HelpRouter,
	AccountRouter,
	DraftRouter,
	// PulseRouter,
	GameSelectorRouter,
	ActivateGameRouter,
	PasswordRouter,
	OffSeasonRouter,
	FantasyCoachRouter
}